import {
  ACTION_CHANGE_PASSWORD__REQUEST,
  ACTION_CHANGE_PASSWORD__SUCCESS,
  ACTION_CHANGE_PASSWORD__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_CHANGE_PASSWORD__REQUEST:
    case ACTION_CHANGE_PASSWORD__SUCCESS:
      return null;

    case ACTION_CHANGE_PASSWORD__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
